import { render, staticRenderFns } from "./cards-board-column.vue?vue&type=template&id=1b424e70&scoped=true"
import script from "./cards-board-column.vue?vue&type=script&lang=js"
export * from "./cards-board-column.vue?vue&type=script&lang=js"
import style0 from "./cards-board-column.vue?vue&type=style&index=0&id=1b424e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b424e70",
  null
  
)

export default component.exports